import { ref } from 'vue'
import axios from '@/plugins/axiosInstance'

/**
 * Create and export state for use-content-generation composable
 */
export const createContentState = () => {
  return {
    isGenerating: ref(false),
    generatedContent: ref(null),
    previousContent: ref(null),
    lastGenerationParams: ref(null),
    cancelTokenSource: ref(null),
  }
}
